import State from 'store/State';
import { selectWidgetInstancesState } from 'widgets/store/selectors';

export const selectIntraDayProfileWidgetsState = (state: State) =>
    selectWidgetInstancesState(state).intradayProfiles;

export const selectIntraDayProfileState = (state: State, widgetKey: string) =>
    selectIntraDayProfileWidgetsState(state)[widgetKey];
